import { render } from "./StepItem.vue?vue&type=template&id=053c8c56"
import script from "./StepItem.vue?vue&type=script&lang=ts"
export * from "./StepItem.vue?vue&type=script&lang=ts"
script.render = render

export default script